import React from 'react';
import { Container, Heading, Box, Text, SimpleGrid } from '@chakra-ui/react';
import {
  CIL,
  PASTI_INTRO,
  PASTI_REVIEWS,
  SECTION_TITLE_CONTAINER_BG,
  SECTION_TITLE_TEXT_COLOR,
} from './constants';

const STAR = '★';
const STAR_EMPTY = '☆';

const StarRating = ({ stars, maxStars = 5 }) => (
  <Text
    as="span"
    fontSize="lg"
    color={CIL.yellow}
    letterSpacing="2px"
    aria-label={`Valutazione: ${stars} su ${maxStars}`}
  >
    {STAR.repeat(stars)}
    <Text as="span" color="gray.300" aria-hidden>
      {STAR_EMPTY.repeat(maxStars - stars)}
    </Text>
  </Text>
);

const PastiSection = () => (
  <Box
    as="section"
    id="section-pasti"
    py={{ base: 10, md: 14 }}
    scrollMarginTop={{ base: '80px', md: '140px' }}
  >
    <Box w="100%" maxW="100%" px={{ base: 4, md: 6, lg: 8 }}>
      <Heading as="h2" size="lg" mb={{ base: 6, md: 8 }} textAlign="center">
        <Box
          w="100%"
          px={4}
          py={3}
          borderRadius="lg"
          sx={{ background: SECTION_TITLE_CONTAINER_BG }}
          boxShadow="sm"
        >
          <Text as="span" fontWeight="bold" color={SECTION_TITLE_TEXT_COLOR}>
            Pasti
          </Text>
        </Box>
      </Heading>

      <Box
        w="100%"
        maxW="100%"
        bg={{ base: 'transparent', md: 'gray.50' }}
        borderRadius="2xl"
        py={8}
      >
        <Container maxW="container.lg" px={0}>
          <Box
            mb={10}
            px={{ base: 4, md: 0 }}
            py={{ base: 5, md: 0 }}
            bg={{ base: 'white', md: 'transparent' }}
            borderRadius={{ base: 'xl', md: 0 }}
            boxShadow={{ base: 'sm', md: 'none' }}
            borderWidth={{ base: '1px', md: 0 }}
            borderColor="gray.100"
          >
            <Text
              textAlign="center"
              maxW="container.md"
              mx="auto"
              fontSize={{ base: 'md', md: 'lg' }}
              color="gray.700"
              lineHeight="tall"
            >
              {PASTI_INTRO}
            </Text>
          </Box>

          <SimpleGrid
            columns={{ base: 1, md: 2 }}
            spacing={6}
            maxW="800px"
            mx="auto"
          >
            {PASTI_REVIEWS.map((review) => (
              <Box
                key={review.text}
                bg="white"
                p={6}
                borderRadius="xl"
                boxShadow="sm"
                borderWidth="1px"
                borderColor="gray.100"
              >
                <Box display="flex" justifyContent="center" mb={2}>
                  <StarRating stars={review.stars} maxStars={review.maxStars} />
                </Box>
                <Text
                  fontStyle="italic"
                  color="gray.800"
                  mt={3}
                  mb={2}
                  fontSize="sm"
                  lineHeight="tall"
                >
                  &quot;{review.text}&quot;
                </Text>
                <Text fontSize="xs" color="gray.500">
                  {review.source}
                </Text>
              </Box>
            ))}
          </SimpleGrid>
        </Container>
      </Box>
    </Box>
  </Box>
);

export default PastiSection;
